import axios from "~/plugins/axios";

export default {

  autofill(
    postalCode,
    number = null,
    include = [],
  ) {
    return axios.post("/web_api/v1/property/autofill", {
      postal_code: postalCode,
      number,
    }, { params: { include } }).then((response) => response.data);
  },
  findById(propertyId, include = []) {
    return this.find(propertyId, include);
  },
  findByPostalCodeNumberNumberLetterAndNumberAddition(
    postalCode, number, numberLetter, numberAddition, include = [],
  ) {
    return axios.post("/web_api/v1/property/by_address", {
      postal_code: postalCode,
      number,
      number_letter: numberLetter,
      number_addition: numberAddition,
    }, { params: { include } }).then((response) => response.data);
  },
  getSuggestionsByPostalCodeNumberNumberLetterAndNumberAddition(
    postalCode, number, numberLetter, numberAddition, include = [],
  ) {
    return axios.post("/web_api/v1/property/suggestions", {
      postal_code: postalCode,
      number,
      number_letter: numberLetter,
      number_addition: numberAddition,
    }, { params: { include } }).then((response) => response.data);
  },
  find(propertyId, include = []) {
    return axios.get(`/web_api/v1/property/${propertyId}`, { params: { include } }).then((response) => response.data);
  },
  create(property) {
    return axios.post("/web_api/v1/property", property).then((response) => response.data);
  },
  update(property) {
    return axios.put(`/web_api/v1/property/${property.id}`, property).then((response) => response.data);
  },
  updateWithJumba(property) {
    return axios.put(`/web_api/v1/property/${property.id}/update_with_jumba`, {}).then((response) => response.data);
  },
  findByCustomerProperty(customerPropertyId, include = []) {
    return axios.get(`/web_api/v1/property/by_customer_property/${customerPropertyId}`, {
      params: { include },
    }).then((response) => response.data);
  },
  getTemplate() {
    return axios.get("/web_api/v1/property/template").then((response) => response.data);
  },
  getPropertiesAssociatedWithCustomer(customerId) {
    return axios.get(`/web_api/v1/property/associated_with_customer/${customerId}`).then((response) => response.data);
  },
  findCurrentByCustomerAndAddressType(customerId, addressType, include) {
    return axios.get(`/web_api/v1/property/current_by_customer_and_type/${customerId}/${addressType}`, {
      params: { include },
    }).then((response) => response.data);
  },
};
